export function downloadCsv(filename, rows) {
    const csv = rows.map((r) => Object.values(r).map((v) => escapeCell(v)).join(',')).join('\n')
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = filename
    a.click()
    URL.revokeObjectURL(url)
}

function escapeCell(value) {
    if (value == null) return ''
    const str = String(value)
    if (/[",\n]/.test(str)) {
        return '"' + str.replace(/"/g, '""') + '"'
    }
    return str
}


